import AsyncStorage from '@react-native-async-storage/async-storage';
import { useCallback } from 'react';
import { log } from '../../tools/LogHelper';

export function useUserSesstionTimeout() {
  const EXPIRE_TIME_KEY = 'expireTime';
  const getExpireTime = useCallback(
    async () => parseInt((await AsyncStorage.getItem(EXPIRE_TIME_KEY)) || ''),
    []
  );
  const updateExpireTime = useCallback(() => {
    const mins = 15;
    log('updating expire time to ', mins);
    AsyncStorage.setItem(
      EXPIRE_TIME_KEY,
      (Date.now() + mins * 60 * 1000).toString()
    );
  }, []);

  const isSessionExpired = useCallback(async () => {
    const expireTime = await getExpireTime();
    if (isFinite(expireTime) && expireTime < Date.now()) {
      log('session ended expireTime', expireTime);
      AsyncStorage.removeItem(EXPIRE_TIME_KEY);
      return true;
    }
    log('session still good', expireTime);
    return false;
  }, [getExpireTime]);

  return { updateExpireTime, isSessionExpired };
}
